import { IconNameV1 } from 'common/icon/iconV1.js';

// export enum HazardType {
//   weatherHazards = 'weather-hazards',
//   Rain = 'rain',
//   wind = 'wind',
//   snow = 'snow',
//   windChill = 'wind-chill',
//   thunderstorm = 'thunderstorm',
// }

export type HazardType = 'SNOW' | 'RAIN' | 'THUNDERSTORM' | 'WIND' | 'WIND_CHILL' | 'WEATHER';

export interface IHazardInfo {
  hazards?: IHazards[];
  message?: string;
  shortMessage?: string;
  title?: string;
  hazardsDisclaimer?: string;
}

export interface IHazards {
  displayName?: string; // Wind
  impactStatement?: string; // e.g. Gale force winds can make movement harder and more tiring
  type?: HazardType;
}

export enum HazardStateEnum {
  NotDefined = 'NotDefined',
  NoHazards = 'NoHazards',
  HasHazards = 'HasHazards',
}

interface IHasHazards {
  hazardState: HazardStateEnum.HasHazards;
  displayIcons: IHazards[];
  hiddenIcons: IHazards[];
}

export interface INoHazards {
  hazardState: HazardStateEnum.NoHazards | HazardStateEnum.NotDefined;
  textLong?: string;
  textShort?: string;
  style: {
    [key: string]: string;
  };
}

export type IHazardState = IHasHazards | INoHazards;

function getHazardEnumState(hazards: IHazards[] | undefined) {
  if (!hazards) {
    return HazardStateEnum.NotDefined;
  } else if (hazards.length === 0) {
    return HazardStateEnum.NoHazards;
  }
  return HazardStateEnum.HasHazards;
}

/** Faded text style for tab if is NA */
const getTabTextStyle = (
  textShort: string | undefined,
): {
  [key: string]: string;
} => {
  if (textShort === 'N/A') {
    return { color: '#7B87A7' };
  }
  return {};
};

/**
 * Displays hazards within the forecast tab
 * @param {string[]} hazardArr
 * @returns Hazard synmbols
 */
export function getHazardState({
  hazardsInfo,
  display,
}: {
  hazardsInfo: IHazardInfo | undefined;
  display: number;
}): IHazardState {
  const hazardState = getHazardEnumState(hazardsInfo?.hazards);
  if (hazardState === HazardStateEnum.HasHazards) {
    // we know there is a hazard array based on hazard state0
    const displayIcons = ((hazardsInfo?.hazards ?? []) as IHazards[]).filter((i) => i.type);
    const hiddenIcons = displayIcons.splice(display);
    return {
      hazardState,
      displayIcons,
      hiddenIcons,
    };
  }
  return {
    hazardState,
    textLong: hazardsInfo?.message,
    textShort: hazardsInfo?.shortMessage,
    style: getTabTextStyle(hazardsInfo?.shortMessage),
  };
}

export function getHazardIconName(hazardType: HazardType | undefined): IconNameV1 {
  if (hazardType) {
    return `hazard-${hazardType.toLowerCase()}` as IconNameV1;
  }
  return '' as IconNameV1;
}
